import { render, staticRenderFns } from "./IframeGroup.vue?vue&type=template&id=03842f45&"
import script from "./IframeGroup.vue?vue&type=script&lang=js&"
export * from "./IframeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports